<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-thumb-view" class="data-list-container">

    <div>
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <div
            class="
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-between
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
            @click="$router.push(`/suprimentos-locacao/novo-pedido`).catch((err) => {})"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Novo</span>
          </div>
        </div>
      </div>
 <vue-good-table
        ref="my-table"
        selectionInfoClass="mytable"
        style="width: 100%"
        styleClass="vgt-table condensed"
        :search-options="{
          enabled: true,
          trigger: '',
          placeholder: 'Procurar',
          skipDiacritics: true,
        }"
        :pagination-options="paginationOptions"
        :columns="columns"
        :rows="getOrders"
        @on-row-click="onRowClick"
      >
        <div slot="emptystate" class="text-center">
          Nenhum resultado encontrado
        </div>
        <template slot="table-row" slot-scope="order">
          <span class="font-medium" v-if="order.column.field == 'idOrder'">
               <vs-chip :color="color">{{order.row.idOrder }}</vs-chip>
          </span>
          <span
            class="font-medium"
            v-if="order.column.field == 'corporateName'"
            @click.stop="edit(order.row.idOrder)"
           >
            {{ order.row.corporateName }}
          </span>
          <span class="font-medium" v-if="order.column.field == 'stage'">
            <div v-if="order.row.stage == 'Conferência'">
              <vs-button
                @click.stop="openStage(order.row.idOrder)"
                color="#1E90FF"
                type="flat"
                >{{ order.row.stage }}</vs-button
              >
            </div>
            <div v-show="order.row.stage == 'Faturamento'">
              <vs-button
                @click.stop="openStage(order.row.idOrder)"
                color="success"
                type="flat"
                >{{ order.row.stage }}</vs-button
              >
            </div>
  
              <div v-show="order.row.stage == 'Estoque'">
                <vs-button
                  @click.stop="openStage(order.row.idOrder)"
                  color="warning"
                  type="flat"
                  >{{ order.row.stage }}</vs-button
                >
              </div>
            <div v-show="order.row.stage == 'Concluído'">
              <vs-button
                @click.stop="openStage(order.row.idOrder)"
                color="primary"
                type="flat"
                >{{ order.row.stage }}</vs-button
              >
            </div>
          </span>
          <span class="font-medium" v-if="order.column.field == 'dateOrder'">
            {{ order.row.dateOrder }}
          </span>
          <span class="font-medium" v-if="order.column.field == 'totalOrder'">
            {{ order.row.totalOrder }}
          </span>
          <span class="font-medium" v-if="order.column.field == 'orderType'">
            <vs-chip :color="color">
              {{ order.row.orderType }}
            </vs-chip>
          </span>
          <span class="font-medium" v-if="order.column.field == 'photo'">
             <!--{{ order.row.userName }}-->
            <vx-tooltip :text="order.row.userName" position="left">
              <vs-avatar
                :src="order.row.photo"
                size="30px"
                class="border-2 border-white border-solid -m-1"
              ></vs-avatar>
            </vx-tooltip>
          </span>
          <span v-if="order.column.field === 'action'">
            <div align="center">
              <vs-dropdown vs-custom-content vs-trigger-click>
                <a
                  class="flex items-center"
                  style="font-weight: 500; font-size: 1rem"
                  href="#"
                >
                  Mais <i class="material-icons"> expand_more </i>
                </a>
                <vs-dropdown-menu class="w-48">
                  <vs-dropdown-item @click.stop="open(order.row.idOrder)">
                    <font-awesome-icon :icon="['fa', 'search']" class="w-4" />
                    Visualizar
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="download(order.row.idOrder, order.row.corporateName)"
                    ><font-awesome-icon
                      :icon="['far', 'file-pdf']"
                      class="w-4"
                    />
                    Download
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    divider
                    @click.stop="deleteData(order.row.idOrder)"
                  >
                    <font-awesome-icon
                      :icon="['far', 'trash-alt']"
                      class="w-4"
                    />
                    Excluir
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </span>
        </template>
      </vue-good-table>
  </div>

   
    <OrderReport ref="orderReport"></OrderReport>
  </div>
</template>

<script>
import OrderReport from "../report/orderReport";
import { VueGoodTable } from "vue-good-table";
export default {
  components: {
    OrderReport,
    VueGoodTable,
  },
   props: {
     orders: {
        default: () => []
    },
  }, 
  data() {
    return {
      selected: [],
      color: null,
      action: null,
      columns: [],
      paginationOptions: {
        enabled: true,
        nextLabel: "Próxima",
        prevLabel: "Anterior",
        rowsPerPageLabel: "Resultados por página",
        ofLabel: "de",
        pageLabel: "Página",
        allLabel: "Todos",
        mode: "pages",
        perPage: 50,
      },
    };
  },
  computed: {
    getOrders() {
      let orders;
      orders = this.orders
      this.color = "dark";
      this.action = "leaseSupplies/trashLeaseSuppliesOrder";
      return orders;
    },
  },
  methods: {
    open(idOrder) {
      this.$refs.orderReport.open(idOrder, 'suprimentos-locacao');
    },
    edit(idOrder) {
      this.$router.push(`/suprimentos-locacao/editar/${idOrder}`).catch((err) => {});
    },
    async deleteData(idOrder) {
      let payload = {
        idOrder: idOrder,
        loading: this.$vs.loading,
        notify: this.$vs.notify,
      };
      await this.$store.dispatch(this.action, payload);
    },
     async download(idOrder,corporateName) {
      this.$refs.orderReport.download(idOrder, 'suprimentos-locacao',corporateName);
    },
    openStage(idOrder) {
      this.$router.push(`/etapa-suprimentos-locacao/${idOrder}`).catch((err) => {});
    },
     onRowClick(params) {
   
     // Somente para ter a mão do mouse clique
    },
    mountTable() {
      this.columns = [
        {
          label: "Código",
          field: "idOrder",
          tdClass: "align-middle"
        },
        {
          label: "Cliente",
          field: "corporateName",
          tdClass: "align-middle"
        },
        {
          label: "Processo",
          field: "stage",
          tdClass: "align-middle"
        },
        {
          label: "Data",
          field: "dateOrder",
          type: "date",
          dateInputFormat: "dd/MM/yyyy", 
          dateOutputFormat: "dd/MM/yyyy", 
          tdClass: "align-middle"
        },
        {
          label: "Tipo",
          field: "orderType",
          tdClass: "align-middle"
        },
        {
          label: "Consultor",
          field: "photo",
          tdClass: "align-middle"
        },
        {
          label: "Ações",
          field: "action",
          tdClass: "align-middle"
        },
      ];
    },
  },
  async created() {
      this.mountTable();
  },
};
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
